import React, { useEffect } from 'react';
import './index.css';

const inlineCode = (props: any) => {
  useEffect(() => { }, []);


  return (
    <div style={{ display: 'inline', }} data-start={props?.position?.start?.line ?? ''} data-end={props?.position?.end?.line ?? ''} data-page={props?.page ?? 0} className='scrollIcon'>
      <span className="inlineCode">{props.children}</span>
    </div>
  );
};

export default inlineCode;
